import React from 'react';
import { formsSet } from './constants/formsSet';

import { ShowCase, Preview, Controls } from '@components/ShowCase';


const Forms = () => (
  <section>
    <article>
      <ul className="showcase-list">
        {
          formsSet.map((formPreview, i) => (
            <li key={`forms-showcase-${i}`}>
              <ShowCase codeTemplate={formPreview.codeTemplate}>
                <Preview backgroundColor={formPreview.backgroundColor} className={formPreview.previewClass}>
                  {formPreview.component}
                </Preview>
                <Controls optionsGroup={formPreview.optionsGroup} />
              </ShowCase>
            </li>
          ))
        }
      </ul>
    </article>
  </section>
);

export default Forms;



// WEBPACK FOOTER //
// ./src/containers/components/Form/Forms.js